import { Icon, Tooltip } from '@mairistem/composants';
import { Feature, Menu } from '@mairistem/module';

import { MENUS, MODES_REGLEMENTS } from '@/constants';
import { showTooltips } from '@/utils';
import { ModeReglementContextProvider, RecuContextProvider } from '../Context';
import BordereauRemiseContextProvider from '../Context/BordereauRemiseContextProvider';
import ReglementPointageContextProvider from '../Context/ReglementPointageContextProvider';
import { BordereauRemise } from './BordereauRemise';
import { PointageBordereaux } from './PointageBordereaux';

const MenuVersementTresor = () => (
  <Menu
    code={MENUS.MENU_VERSEMENT_TRESOR}
    name="Versements / Remises"
    icon={
      showTooltips ? (
        <Tooltip
          trigger={<Icon name="paper plane" />}
          message="Versements / Remises"
          position="right center"
        />
      ) : (
        <Icon name="paper plane" />
      )
    }
    path="/versements-remises"
  >
    <Menu
      code={MENUS.MENU_POINTAGE_BORDEREAUX}
      name="Contrôle et génération des bordereaux"
      path="/controle-bordereaux"
    >
      <Feature>
        <Feature.Content>
          <ModeReglementContextProvider autoload="régie">
            <RecuContextProvider standAlone>
              <ReglementPointageContextProvider code={MODES_REGLEMENTS.CHEQUE}>
                <ReglementPointageContextProvider code={MODES_REGLEMENTS.NUMERAIRE}>
                  <ReglementPointageContextProvider code={MODES_REGLEMENTS.CESU}>
                    <ReglementPointageContextProvider code={MODES_REGLEMENTS.CHEQUE_VAC}>
                      <ReglementPointageContextProvider code={MODES_REGLEMENTS.CARTE_BANCAIRE}>
                        <ReglementPointageContextProvider code={MODES_REGLEMENTS.VIREMENT}>
                          <ReglementPointageContextProvider code={MODES_REGLEMENTS.PRELEVEMENT}>
                            <ReglementPointageContextProvider
                              code={MODES_REGLEMENTS.CARTE_BANCAIRE_INTERNET}
                            >
                              <ReglementPointageContextProvider
                                code={MODES_REGLEMENTS.PRELEVEMENT_INTERNET}
                              >
                                <ReglementPointageContextProvider code={MODES_REGLEMENTS.TICKET}>
                                  <ReglementPointageContextProvider
                                    code={MODES_REGLEMENTS.BON_CCAS}
                                  >
                                    <ReglementPointageContextProvider
                                      code={MODES_REGLEMENTS.BON_CAF}
                                    >
                                      <PointageBordereaux />
                                    </ReglementPointageContextProvider>
                                  </ReglementPointageContextProvider>
                                </ReglementPointageContextProvider>
                              </ReglementPointageContextProvider>
                            </ReglementPointageContextProvider>
                          </ReglementPointageContextProvider>
                        </ReglementPointageContextProvider>
                      </ReglementPointageContextProvider>
                    </ReglementPointageContextProvider>
                  </ReglementPointageContextProvider>
                </ReglementPointageContextProvider>
              </ReglementPointageContextProvider>
            </RecuContextProvider>
          </ModeReglementContextProvider>
        </Feature.Content>
      </Feature>
    </Menu>
    <Menu code={MENUS.MENU_BORDEREAUX_REMISE} name="Bordereaux de remise" path="/bordereaux-remise">
      <Feature>
        <Feature.Content>
          <ModeReglementContextProvider autoload="régie">
            <BordereauRemiseContextProvider code={MODES_REGLEMENTS.CHEQUE}>
              <BordereauRemiseContextProvider code={MODES_REGLEMENTS.NUMERAIRE}>
                <BordereauRemiseContextProvider code={MODES_REGLEMENTS.CESU}>
                  <BordereauRemiseContextProvider code={MODES_REGLEMENTS.CHEQUE_VAC}>
                    <BordereauRemiseContextProvider code={MODES_REGLEMENTS.CARTE_BANCAIRE}>
                      <BordereauRemiseContextProvider code={MODES_REGLEMENTS.VIREMENT}>
                        <BordereauRemiseContextProvider code={MODES_REGLEMENTS.PRELEVEMENT}>
                          <BordereauRemiseContextProvider
                            code={MODES_REGLEMENTS.CARTE_BANCAIRE_INTERNET}
                          >
                            <BordereauRemiseContextProvider
                              code={MODES_REGLEMENTS.PRELEVEMENT_INTERNET}
                            >
                              <BordereauRemiseContextProvider code={MODES_REGLEMENTS.TICKET}>
                                <BordereauRemiseContextProvider code={MODES_REGLEMENTS.BON_CCAS}>
                                  <BordereauRemiseContextProvider code={MODES_REGLEMENTS.BON_CAF}>
                                    <BordereauRemise />
                                  </BordereauRemiseContextProvider>
                                </BordereauRemiseContextProvider>
                              </BordereauRemiseContextProvider>
                            </BordereauRemiseContextProvider>
                          </BordereauRemiseContextProvider>
                        </BordereauRemiseContextProvider>
                      </BordereauRemiseContextProvider>
                    </BordereauRemiseContextProvider>
                  </BordereauRemiseContextProvider>
                </BordereauRemiseContextProvider>
              </BordereauRemiseContextProvider>
            </BordereauRemiseContextProvider>
          </ModeReglementContextProvider>
        </Feature.Content>
      </Feature>
    </Menu>
  </Menu>
);

export default MenuVersementTresor;
